import { AspectRatio, AspectRatioProps, Box, Image } from "@chakra-ui/react";
import TraitImage, { TraitImageProps } from "components/TraitImage";
import { publicUrl, traitRangesByCategory } from "config";
import { useMemo } from "react";
import { TraitCategory } from "types";

export type TraitsCanvasProps = {
  traits: number[];
  furColor: number;
  imagesSize?: "256" | "512" | "1024";
} & Omit<AspectRatioProps, "ratio">;

const TraitsCanvas = ({
  traits,
  furColor,
  imagesSize = "512",
  ...rest
}: TraitsCanvasProps) => {
  const hasBigHat = useMemo(
    () =>
      traits.some(
        (tokenId) =>
          tokenId >= traitRangesByCategory[TraitCategory.Hat][0] + 499 &&
          tokenId <= traitRangesByCategory[TraitCategory.Hat][1]
      ),
    [traits]
  );

  const defaultProps: Omit<TraitImageProps, "tokenId"> = {
    furColor,
    size: imagesSize,
    position: "absolute",
    top: "0",
    left: "0",
    w: "full",
  };

  return (
    <AspectRatio ratio={1} w="full" bg="bright.300" {...rest}>
      <Box
        userSelect="none"
        pointerEvents="none"
        w="full"
        bg="bright.300"
        {...rest}
      >
        <Image src={`${publicUrl}/bear-placeholder_transparent.png`} />

        {/* Background */}
        <TraitImage tokenId={traits[0]} {...defaultProps} />
        {/* Fur */}
        <TraitImage tokenId={traits[1]} {...defaultProps} />
        {/* Clothes */}
        <TraitImage tokenId={traits[2]} {...defaultProps} />
        {/* Eyes */}
        <TraitImage tokenId={traits[3]} {...defaultProps} />
        {/* Mouth */}
        <TraitImage tokenId={traits[4]} {...defaultProps} />
        {/* Ears L & R */}
        {hasBigHat ? (
          <TraitImage tokenId={traits[5]} postfix="l" {...defaultProps} />
        ) : (
          <TraitImage tokenId={traits[5]} {...defaultProps} />
        )}
        {/* Hat */}
        <TraitImage tokenId={traits[6]} {...defaultProps} />
        {/* Optional ear */}
        {hasBigHat && (
          <TraitImage tokenId={traits[5]} postfix="r" {...defaultProps} />
        )}
        {/* Special */}
        {traits[7] && <TraitImage tokenId={traits[7]} {...defaultProps} />}
      </Box>
    </AspectRatio>
  );
};

export default TraitsCanvas;
